import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { queryKeys } from '../react-query.config';

export const useUserDetails = () =>
  useQuery({
    queryKey: queryKeys.user.details(),
    queryFn: async () => {
      return apiClient.get('/api/user-details');
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  });
